import { render, staticRenderFns } from "./Variables.vue?vue&type=template&id=53a46d4e&scoped=true&"
import script from "./Variables.vue?vue&type=script&lang=ts&"
export * from "./Variables.vue?vue&type=script&lang=ts&"
import style0 from "./Variables.vue?vue&type=style&index=0&id=53a46d4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a46d4e",
  null
  
)

export default component.exports